module.exports = __webpack_public_path__ + "img/activityTitle2.e75f3b4.png";